var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('section',{staticClass:"modal",class:{ 'can-overflow': _vm.overflow }},[_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.close()}}}),_c('div',{class:{
      'large-box': _vm.largebox,
      'modal-box': !_vm.largebox,
      'guide-box': _vm.guidebox,
      'alert-box': _vm.alertBox,
      proPlanModal: _vm.proPlanModal,
      shareChannel: _vm.shareChannel,
    }},[(!_vm.notClose)?_c('a',{staticClass:"close",on:{"click":function($event){return _vm.close()}}},[_vm._v("×")]):_vm._e(),(_vm.title)?_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"modal-content"},[_vm._t("content")],2),_c('div',{staticClass:"modal-action"},[_vm._t("action")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }